export default __webpack_public_path__ + "static/Carro-eletrico-cc3718712bb0b2152041bc57577eb997.svg";